(function (scope) {
  const colorLabels = Object.freeze({
    'hot-pink': 'Hot Pink', 'royal-blue': 'Royal Blue', yellow: 'Yellow',
    'light-pink': 'Light Pink', red: 'Red', orange: 'Orange', green: 'Green',
    aqua: 'Aqua', 'light-blue': 'Light Blue', purple: 'Purple',
    'light-grey': 'Light Grey', black: 'Black', beige: 'Beige', white: 'White',
    'dark-grey': 'Dark Grey', brown: 'Brown', navy: 'Navy', 'off-white': 'Off-White',
    maroon: 'Maroon', 'dark-green': 'Dark Green', 'rust-orange': 'Rust Orange',
    'olive-green': 'Olive Green', 'mustard-yellow': 'Mustard Yellow',
    'teal-blue': 'Teal Blue', 'peach-pink': 'Peach', 'dark-purple': 'Dark Purple'
  });

  function displayLabel(value, optionName, locale) {
    if (!/^en(?:-|$)/i.test(locale || 'en')) return value;
    const option = String(optionName).trim().toLowerCase();
    if (option === 'color' || option === 'colour') return colorLabels[value] || value;
    if (option !== 'size') return value;
    const age = String(value).match(/^(\d+(?:-\d+)?) (year|years|month|months)$/i);
    if (age) return age[1] + ' ' + (/^year/i.test(age[2]) ? 'Years' : 'Months');
    if (/^x-small$/i.test(value)) return 'X-Small';
    return value;
  }

  function ensureNativeSavingsTarget(win, container) {
    const instance = win.theme?.sections?.instances?.find(item => item.container === container);
    if (!instance?.cache || instance.cache.savePrice) return false;
    const price = container.querySelector('[data-product-price]');
    if (!price) return false;
    const target = win.document.createElement('span');
    target.hidden = true;
    target.setAttribute('data-solid-native-savings', '');
    price.insertAdjacentElement('afterend', target);
    instance.cache.savePrice = target;
    return true;
  }

  function reviewUrl(url, view) {
    if (!['solid-pajamas', 'solid-pajamas-classic', 'solid-pajamas-adult'].includes(view)) return url;
    const parsed = new URL(url);
    parsed.searchParams.set('view', view);
    return parsed.href;
  }

  function publishProductView(win, state, target, element) {
    const payload = { productId: String(state.productId), variantId: String(state.variant.id), handle: state.handle,
      title: state.socialTitle, url: new URL(target.pathname + '?variant=' + state.variant.id, target.origin).href };
    element.dataset.analyticsProductId = payload.productId;
    element.dataset.analyticsVariantId = payload.variantId;
    element.dataset.analyticsStatus = 'unavailable';
    const analytics = win.Shopify?.analytics;
    if (typeof analytics?.publish !== 'function') return;
    try {
      element.dataset.analyticsStatus = 'submitted';
      Promise.resolve(analytics.publish('leveret:product_viewed', payload)).then(result => {
        if (element.dataset.analyticsVariantId === payload.variantId) element.dataset.analyticsStatus = result === false ? 'rejected' : 'published';
      }).catch(() => {
        if (element.dataset.analyticsVariantId === payload.variantId) element.dataset.analyticsStatus = 'failed';
      });
    } catch { element.dataset.analyticsStatus = 'failed'; }
  }

  const siblingHandles = Object.freeze(['solid-color-cotton-pajamas-colors', 'solid-color-cotton-pajamas-neutrals', 'kids-solidcolor-longsleeve-cotton-pajamas']);

  function fastNavigationAllowed(state) {
    return state?.analytics?.country === 'US' && state.analytics.currency === 'USD';
  }

  class SolidProviderViews {
    constructor(win) { this.win = win; this.current = null; }

    seed(state) {
      if (this.current === null && state?.variant) this.current = String(state.productId) + ':' + String(state.variant.id);
    }

    view(state, target, element) {
      const diagnostic = element.dataset;
      diagnostic.metaStatus = diagnostic.convertCartStatus = 'invalid';
      const identity = String(state?.productId) + ':' + String(state?.variant?.id);
      if (!state || !siblingHandles.includes(state.handle) || !/^\d+$/.test(String(state.productId)) ||
          !/^\d+$/.test(String(state.variant?.id)) || target.origin !== this.win.location.origin ||
          target.pathname.split('/').pop() !== state.handle || target.searchParams.get('variant') !== String(state.variant.id) ||
          !Number.isSafeInteger(state.variant.price) || state.variant.price < 0 || !state.socialTitle) return;
      if (identity === this.current) { diagnostic.metaStatus = diagnostic.convertCartStatus = 'duplicate-skipped'; return; }
      this.current = identity;
      if (!fastNavigationAllowed(state)) { diagnostic.metaStatus = diagnostic.convertCartStatus = 'market-unverified'; return; }
      const privacy = this.win.Shopify?.customerPrivacy;
      let marketing = false;
      let analytics = false;
      try {
        marketing = privacy?.marketingAllowed?.() === true && privacy?.saleOfDataAllowed?.() === true;
        analytics = privacy?.analyticsProcessingAllowed?.() === true;
      } catch { diagnostic.metaStatus = diagnostic.convertCartStatus = 'consent-unavailable'; return; }
      diagnostic.metaStatus = 'consent-blocked';
      if (marketing) {
        diagnostic.metaStatus = 'tag-unavailable';
        if (typeof this.win.fbq === 'function') {
          try {
            this.win.fbq('trackSingle', '2580775172005330', 'ViewContent', {
              content_ids: [String(state.variant.id)], content_type: 'product', content_name: state.socialTitle,
              currency: 'USD', value: state.variant.price / 100
            });
            diagnostic.metaStatus = 'submitted';
            diagnostic.metaVariantId = String(state.variant.id);
          } catch { diagnostic.metaStatus = 'failed'; }
        }
      }
      diagnostic.convertCartStatus = 'consent-blocked';
      if (marketing && analytics) {
        diagnostic.convertCartStatus = 'adapter-unavailable';
        if (typeof this.win.ccart === 'function' && (this.win.ccLayer === undefined || Array.isArray(this.win.ccLayer))) {
          try {
            const image = state.variant.featured_image?.src ||
              (Array.isArray(state.structuredData?.image) ? state.structuredData.image[0] : state.structuredData?.image);
            const payload = {
              ccEvent: 'productViewed', src: 'scraping', id: Number(state.productId), child_id: Number(state.variant.id),
              name: state.socialTitle, url: new URL(target.pathname + '?variant=' + state.variant.id, target.origin).href,
              price: state.variant.price / 100, currency: 'USD', inStock: state.variant.available === true
            };
            if (image) payload.image = new URL(image, target.origin).href;
            if (this.win.ccLayer === undefined) this.win.ccLayer = [];
            this.win.ccLayer.push(payload);
            diagnostic.convertCartStatus = 'queued';
            diagnostic.convertCartVariantId = String(state.variant.id);
          } catch { diagnostic.convertCartStatus = 'failed'; }
        }
      }
    }
  }

  class SolidGa4Views {
    constructor(win) { this.win = win; this.current = null; }

    seed(state) {
      if (this.current === null && state?.variant) this.current = String(state.productId) + ':' + String(state.variant.id);
    }

    view(state, target, element) {
      const diagnostic = element.dataset;
      diagnostic.ga4Status = 'invalid';
      const identity = String(state?.productId) + ':' + String(state?.variant?.id);
      if (!state || !siblingHandles.includes(state.handle) || !/^\d+$/.test(String(state.productId)) ||
          !/^\d+$/.test(String(state.variant?.id)) || target.origin !== this.win.location.origin ||
          target.pathname.split('/').pop() !== state.handle || target.searchParams.get('variant') !== String(state.variant.id)) return;
      if (identity === this.current) { diagnostic.ga4Status = 'duplicate-skipped'; return; }
      this.current = identity;
      if (state.analytics?.country !== 'US' || state.analytics?.currency !== 'USD') {
        diagnostic.ga4Status = 'market-unverified'; return;
      }
      const price = state.variant.price;
      if (!Number.isSafeInteger(price) || price < 0 || !state.socialTitle || !state.analytics.brand) return;
      try {
        if (this.win.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) {
          diagnostic.ga4Status = 'consent-blocked'; return;
        }
        if (typeof this.win.gtag !== 'function') { diagnostic.ga4Status = 'tag-unavailable'; return; }
        const payload = {
          send_to: 'G-YK2X3W5LK0', currency: 'USD', value: price / 100,
          page_location: new URL(target.pathname + '?variant=' + state.variant.id, target.origin).href,
          page_title: state.socialTitle, leveret_source: 'solid_pajamas_navigation',
          items: [{ item_id: 'shopify_US_' + state.productId + '_' + state.variant.id,
            item_name: state.socialTitle, item_brand: state.analytics.brand,
            item_category: state.analytics.category, item_variant: state.variant.title,
            sku: state.variant.sku, variant_id: String(state.variant.id), price: price / 100, quantity: 1 }]
        };
        this.win.gtag('event', 'view_item', payload);
        diagnostic.ga4Status = 'submitted';
        diagnostic.ga4ProductId = String(state.productId);
        diagnostic.ga4VariantId = String(state.variant.id);
      } catch { diagnostic.ga4Status = 'failed'; }
    }
  }

  function siblingState(productUrl, variants, size, baseUrl, view) {
    const target = new URL(productUrl, baseUrl);
    const base = new URL(baseUrl);
    const handle = target.pathname.split('/').pop();
    if (target.origin !== base.origin || !siblingHandles.includes(handle)) return null;
    const variant = variants.find(item => item.size === size);
    if (!variant || !/^\d+$/.test(String(variant.id))) return null;
    target.searchParams.set('variant', String(variant.id));
    return { url: reviewUrl(target.href, view), available: variant.available, id: String(variant.id) };
  }

  function sectionRequestUrl(url, sectionId, baseUrl) {
    const target = new URL(url, baseUrl);
    const base = new URL(baseUrl);
    if (target.origin !== base.origin || !siblingHandles.includes(target.pathname.split('/').pop())) return null;
    if (!/^\d+$/.test(target.searchParams.get('variant') || '') || !/^[\w-]+$/.test(sectionId || '')) return null;
    target.searchParams.delete('sections');
    target.searchParams.set('section_id', sectionId);
    return target.href;
  }

  class RequestGate {
    constructor() { this.version = 0; }
    begin() { return ++this.version; }
    current(version) { return version === this.version; }
    cancel() { this.version++; }
  }

  class ProductSectionCache {
    constructor(win, now = () => Date.now()) {
      this.win = win;
      this.now = now;
      this.entries = new Map();
      this.ttl = 15000;
      this.limit = 6;
      this.speculative = 0;
    }

    clear() { this.entries.clear(); }
    forget(url) { this.entries.delete(url); }

    entry(url) {
      const entry = this.entries.get(url);
      if (entry && (entry.signal?.aborted || (entry.ready && this.now() - entry.completedAt >= this.ttl))) {
        this.forget(url);
        return null;
      }
      return entry;
    }

    start(url, signal, speculative = false) {
      const entry = { ready: false, completedAt: 0, signal };
      this.entries.set(url, entry);
      while (this.entries.size > this.limit) this.forget(this.entries.keys().next().value);
      entry.promise = this.win.fetch(url, { signal, credentials: 'same-origin', cache: 'no-store' }).then(async response => {
        if (!response.ok) throw new Error('Product section unavailable');
        const html = await response.text();
        if (signal?.aborted) throw new Error('Product request cancelled');
        entry.ready = true;
        entry.completedAt = this.now();
        return html;
      }).catch(error => {
        if (this.entries.get(url) === entry) this.forget(url);
        throw error;
      }).finally(() => {
        if (speculative) this.speculative--;
      });
      return entry;
    }

    async read(url, signal) {
      let entry = this.entry(url);
      const source = entry ? (entry.ready ? 'cache' : 'prefetch') : 'network';
      if (!entry) entry = this.start(url, signal);
      const html = await new Promise((resolve, reject) => {
        const abort = () => reject(new Error('Product request cancelled'));
        if (signal?.aborted) return abort();
        signal?.addEventListener('abort', abort, { once: true });
        entry.promise.then(resolve, reject).finally(() => signal?.removeEventListener('abort', abort));
      });
      return { html, source };
    }

    prefetch(url) {
      const existing = this.entry(url);
      if (existing) return existing.promise;
      const connection = this.win.navigator?.connection;
      if (this.speculative >= 2 || connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '')) return null;
      this.speculative++;
      const controller = new this.win.AbortController();
      const timeout = this.win.setTimeout(() => controller.abort(), 5000);
      return this.start(url, controller.signal, true).promise.finally(() => this.win.clearTimeout(timeout));
    }
  }

  function parseProductSection(win, html, url) {
    const doc = new win.DOMParser().parseFromString(html, 'text/html');
    const next = doc.querySelector('leveret-solid-pajamas');
    const state = JSON.parse(next?.querySelector('[data-solid-page]')?.textContent || 'null');
    const target = new URL(url, win.location.href);
    if (!next || !state || state.handle !== target.pathname.split('/').pop() || String(state.variant?.id) !== target.searchParams.get('variant')) throw new Error('Product identity mismatch');
    const product = next.querySelector('.product-section');
    if (product?.dataset.productId !== state.productId || next.querySelectorAll('[data-solid-color]').length !== 26 || !next.querySelector('[data-variant-json]')) throw new Error('Incomplete product section');
    return { next, state, target };
  }

  function initProductGlobals(theme, element) {
    if (theme.collapsibles?.init) {
      theme.collapsibles.init(element);
      if (element.querySelector('a[href*="youtube.com/watch"],a[href*="youtu.be/"],a[href*="player.vimeo.com/player/"],a[href*="vimeo.com/"],.product-video-trigger--mp4')) theme.videoModal?.();
    } else theme.initGlobals();
  }

  class ProductNavigation {
    constructor(win) {
      this.win = win;
      this.ga4 = new SolidGa4Views(win);
      this.providers = new SolidProviderViews(win);
      this.gate = new RequestGate();
      this.cache = new ProductSectionCache(win);
      this.images = new Map();
      win.addEventListener('pageshow', () => { this.cache.clear(); this.images.clear(); });
      win.document?.addEventListener('visibilitychange', () => {
        if (win.document.visibilityState === 'hidden') { this.cache.clear(); this.images.clear(); }
      });
      win.addEventListener('popstate', () => {
        if (!this.element || !this.element.isConnected) return;
        const current = this.element.productSection?.dataset.productHandle;
        const id = this.element.querySelector('[data-product-select]')?.value;
        const target = new URL(win.location.href);
        if (current === target.pathname.split('/').pop() && id === target.searchParams.get('variant')) {
          this.cancel();
          return;
        }
        const url = sectionRequestUrl(win.location.href, this.element.dataset.sectionId, win.location.href);
        if (!url) return;
        this.load(win.location.href, { history: true, scroll: win.history.state?.leveretSolid?.scroll });
      });
    }

    cancel() {
      this.gate.cancel();
      if (this.controller) this.controller.abort();
      if (this.element) this.element.setLoading(false);
    }

    prefetch(url) {
      const requestUrl = sectionRequestUrl(url, this.element?.dataset.sectionId, this.win.location.href);
      if (!requestUrl) return;
      const pending = this.cache.prefetch(requestUrl);
      if (!pending) return;
      pending.then(html => {
        const { next, state } = parseProductSection(this.win, html, url);
        const selected = state.variant.featured_image?.src;
        const image = selected && Array.from(next.querySelectorAll('img.photoswipe__image')).find(img => {
          const src = img.getAttribute('src');
          return src && new URL(src, url).pathname === new URL(selected, url).pathname;
        });
        if (image && this.win.Image && !this.images.has(requestUrl)) {
          const preload = new this.win.Image();
          preload.sizes = image.getAttribute('sizes') || '';
          preload.srcset = image.getAttribute('srcset') || image.getAttribute('data-srcset') || '';
          preload.src = image.getAttribute('src');
          this.images.set(requestUrl, preload);
          while (this.images.size > 6) this.images.delete(this.images.keys().next().value);
        }
        this.element?.siblingLinks?.forEach(({ link }) => {
          if (link.href === url) link.dataset.solidPrefetch = 'ready';
        });
      }).catch(() => { this.cache.forget(requestUrl); });
    }

    async load(url, options = {}) {
      const element = this.element;
      const win = this.win;
      const requestUrl = sectionRequestUrl(url, element.dataset.sectionId, win.location.href);
      let currentState;
      try { currentState = JSON.parse(element.querySelector('[data-solid-page]')?.textContent || 'null'); }
      catch { win.location.assign(url); return; }
      if (!requestUrl || !win.theme?.sections || !win.theme?.Product || !fastNavigationAllowed(currentState)) {
        win.location.assign(url);
        return;
      }
      this.cancel();
      const version = this.gate.begin();
      const controller = this.controller = new win.AbortController();
      const timeout = win.setTimeout(() => controller.abort(), 10000);
      const scroll = options.scroll || [win.scrollX, win.scrollY];
      element.setLoading(true);
      const started = win.performance?.now() || Date.now();
      try {
        const { html, source } = await this.cache.read(requestUrl, controller.signal);
        if (!this.gate.current(version)) return;
        const { next, state, target } = parseProductSection(win, html, url);
        if (!fastNavigationAllowed(state)) { win.location.assign(url); return; }
        if (!options.history) {
          element.rememberHistory();
          win.history.pushState({ ...win.history.state, leveretSolid: { scroll, url: target.href } }, '', target.href);
        }
        element.setLoading(false);
        const oldSection = element.productSection;
        win.document.dispatchEvent(new win.CustomEvent('shopify:section:unload', { detail: { sectionId: oldSection.dataset.sectionId } }));
        element.disconnectedCallback();
        next.querySelectorAll('script:not([type="application/json"]):not([type="application/ld+json"])').forEach(script => script.remove());
        element.innerHTML = next.innerHTML;
        element.connectedCallback();
        win.theme.sections.register('product', win.theme.Product, element);
        initProductGlobals(win.theme, element);
        element.guardVariantIdentity();
        const instance = win.theme.sections.instances.find(item => item.container === element.productSection);
        const master = element.querySelector('[data-product-select]');
        if (!instance || !master || master.value !== String(state.variant.id)) throw new Error('Product form initialization failed');
        this.updateMetadata(state);
        win.document.documentElement.classList.add('leveret-solid-ajax-swapped');
        element.querySelectorAll('a[href="#opinew-plugin"]').forEach(link => {
          const reviews = new URL(target.href);
          reviews.searchParams.set('solid_reviews', '1');
          reviews.hash = 'opinew-plugin';
          link.href = reviews.href;
        });
        element.dataset.navigationCount = String(Number(element.dataset.navigationCount || 0) + 1);
        element.dataset.activeProductId = state.productId;
        element.dataset.navigationSource = source;
        element.dataset.navigationMs = String(Math.round((win.performance?.now() || Date.now()) - started));
        win.scrollTo({ left: scroll[0], top: scroll[1], behavior: 'instant' });
        if (!options.history) element.siblingLinks.find(item => item.link.getAttribute('aria-current') === 'true')?.link.focus({ preventScroll: true });
        win.document.dispatchEvent(new win.CustomEvent('leveret:product-change', { detail: { productId: state.productId, variantId: String(state.variant.id), url: target.href } }));
        publishProductView(win, state, target, element);
        this.ga4.view(state, target, element);
        this.providers.view(state, target, element);
      } catch {
        if (this.gate.current(version)) {
          this.cache.forget(requestUrl);
          win.location.assign(url);
        }
      } finally {
        win.clearTimeout(timeout);
        if (this.gate.current(version)) {
          this.controller = null;
          element.setLoading(false);
        }
      }
    }

    updateMetadata(state) {
      const doc = this.win.document;
      doc.title = state.title;
      const image = Array.isArray(state.structuredData.image) ? state.structuredData.image[0] : state.structuredData.image;
      const values = { 'meta[name="description"]': ['content', state.description], 'link[rel="canonical"]': ['href', state.canonical], 'meta[property="og:url"]': ['content', state.canonical], 'meta[property="og:title"]': ['content', state.socialTitle], 'meta[property="og:description"]': ['content', state.description], 'meta[property="og:image"]': ['content', image], 'meta[property="og:image:secure_url"]': ['content', image], 'meta[name="twitter:title"]': ['content', state.socialTitle], 'meta[name="twitter:description"]': ['content', state.description], 'meta[name="twitter:image"]': ['content', image] };
      Object.entries(values).forEach(([selector, [attribute, value]]) => doc.head.querySelector(selector)?.setAttribute(attribute, value || ''));
      const next = state.structuredData;
      const keep = doc.getElementById('leveret-product-jsonld');
      if (keep && next && next['@type'] === 'Product') keep.textContent = JSON.stringify(next);
      doc.querySelectorAll('script[type="application/ld+json"]').forEach(script => {
        if (script.id === 'leveret-product-jsonld') return;
        try {
          const data = JSON.parse(script.textContent);
          const type = data && data['@type'];
          const graph = data && Array.isArray(data['@graph']) ? data['@graph'] : null;
          const productGraph = graph && graph.length && graph.every(node => node && (node['@type'] === 'Product' || node['@type'] === 'ProductGroup'));
          if (type === 'Product' || type === 'ProductGroup' || productGraph) script.remove();
        } catch { }
      });
    }
  }

  function stickyPurchaseState(variant, masterId, disabled, loading, submitting) {
    return {
      disabled: Boolean(!variant?.available || String(variant.id) !== String(masterId) || disabled || loading || submitting),
      soldOut: Boolean(variant && !variant.available),
      busy: Boolean(loading || submitting)
    };
  }

  function stickyShouldShow(primaryBottom, overlayOpen, editing, loading) {
    return primaryBottom <= 0 && !overlayOpen && !editing && !loading;
  }

  function submitSticky(form, primary, state) {
    if (!form || !primary || state.disabled || primary.disabled || primary.classList.contains('btn--loading')) return false;
    if (typeof form.requestSubmit === 'function') form.requestSubmit(primary);
    else primary.click();
    return true;
  }

  // No second cart endpoint or form: this is a view of the native purchase state.
  class SolidStickyCart {
    constructor(owner, win) {
      this.owner = owner;
      this.win = win;
      this.bar = owner.querySelector('[data-solid-sticky]');
      this.primary = owner.productSection.querySelector('[data-add-to-cart]');
      this.form = this.primary?.form;
      if (!this.bar || !this.form || !owner.siblingNav) return;
      this.button = this.bar.querySelector('[data-solid-sticky-add]');
      this.selection = this.bar.querySelector('[data-solid-sticky-selection]');
      this.price = this.bar.querySelector('[data-solid-sticky-price]');
      this.nativePrice = owner.productSection.querySelector('[data-product-price]');
      try { this.variants = JSON.parse(owner.querySelector('[data-variant-json]').textContent); } catch { return; }
      this.schedule = () => {
        if (!this.frame) this.frame = win.requestAnimationFrame(() => { this.frame = null; this.update(); });
      };
      this.onClick = () => {
        const variant = owner.guardVariantIdentity();
        const state = this.state(variant);
        if (submitSticky(this.form, this.primary, state)) this.schedule();
      };
      this.button.addEventListener('click', this.onClick);
      win.addEventListener('scroll', this.schedule, { passive: true });
      win.addEventListener('resize', this.schedule);
      win.document.addEventListener('focusin', this.schedule);
      win.document.addEventListener('focusout', this.schedule);
      this.observer = new win.MutationObserver(this.schedule);
      this.observer.observe(this.primary, { attributes: true, childList: true, characterData: true, subtree: true });
      if (this.nativePrice) this.observer.observe(this.nativePrice, { childList: true, characterData: true, subtree: true });
      this.observer.observe(win.document.documentElement, { attributes: true, attributeFilter: ['class'] });
      this.observer.observe(win.document.body, { attributes: true, attributeFilter: ['class'] });
      this.schedule();
    }

    state(variant) {
      return stickyPurchaseState(variant, this.owner.querySelector('[data-product-select]')?.value,
        this.primary.disabled, this.owner.hasAttribute('aria-busy'), this.primary.classList.contains('btn--loading'));
    }

    update() {
      if (!this.owner.isConnected || !this.variants) return;
      const color = this.owner.colorGroup.querySelector('input:checked')?.value;
      const size = this.owner.sizeGroup.querySelector('input:checked')?.value;
      const variant = this.variants.find(item => item.option1 === color && item.option2 === size);
      const state = this.state(variant);
      const selection = [displayLabel(color || '', 'Color', this.owner.locale), displayLabel(size || '', 'Size', this.owner.locale)].join(' / ');
      if (this.selection.textContent !== selection) this.selection.textContent = selection;
      const price = this.nativePrice?.textContent.trim() || '';
      if (this.price.textContent !== price) this.price.textContent = price;
      this.button.disabled = state.disabled;
      const text = state.soldOut ? this.bar.dataset.soldOut : !variant ? this.bar.dataset.unavailable : this.bar.dataset.addLabel;
      const label = this.button.querySelector('span');
      if (label.textContent !== text) label.textContent = text;
      this.button.classList.toggle('btn--loading', state.busy);
      this.bar.setAttribute('aria-busy', String(state.busy));
      const root = this.win.document.documentElement;
      const overlay = this.win.document.body.classList.contains('ccBlurContent') ||
        Array.from(root.classList).some(name => name === 'js-drawer-open' || name.startsWith('modal-open'));
      const focused = this.win.document.activeElement;
      const editing = Boolean(focused?.matches('input:not([type="radio"]):not([type="checkbox"]):not([type="hidden"]),textarea,select,[contenteditable="true"]'));
      const show = stickyShouldShow(this.primary.getBoundingClientRect().bottom, overlay, editing, this.owner.hasAttribute('aria-busy'));
      this.bar.hidden = !show;
      if (root.classList.contains('leveret-solid-sticky-visible') !== show) root.classList.toggle('leveret-solid-sticky-visible', show);
    }

    disconnect() {
      if (!this.schedule) return;
      this.win.cancelAnimationFrame(this.frame);
      this.observer.disconnect();
      this.button.removeEventListener('click', this.onClick);
      this.win.removeEventListener('scroll', this.schedule);
      this.win.removeEventListener('resize', this.schedule);
      this.win.document.removeEventListener('focusin', this.schedule);
      this.win.document.removeEventListener('focusout', this.schedule);
      this.win.document.documentElement.classList.remove('leveret-solid-sticky-visible');
      this.bar.hidden = true;
    }
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { displayLabel, reviewUrl, siblingState, sectionRequestUrl, RequestGate, ProductNavigation, ProductSectionCache, initProductGlobals, stickyPurchaseState, stickyShouldShow, submitSticky, publishProductView, SolidGa4Views, SolidProviderViews, fastNavigationAllowed, ensureNativeSavingsTarget };
  if (!scope.customElements || scope.customElements.get('leveret-solid-pajamas')) return;

  const navigation = new ProductNavigation(scope);

  scope.customElements.define('leveret-solid-pajamas', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.locale = this.dataset.locale || 'en';
      this.reviewView = new URL(scope.location.href).searchParams.get('view');
      this.productSection = this.querySelector('.product-section');
      if (!this.productSection) return;
      this.onNativeChange = () => ensureNativeSavingsTarget(scope, this.productSection);
      this.productSection.addEventListener('change', this.onNativeChange, true);
      navigation.ga4.seed(JSON.parse(this.querySelector('[data-solid-page]')?.textContent || 'null'));
      navigation.providers.seed(JSON.parse(this.querySelector('[data-solid-page]')?.textContent || 'null'));
      this.setupSiblings();
      this.guardVariantIdentity();
      this.querySelectorAll('.variant-input-wrap').forEach(group => {
        const optionName = group.getAttribute('name') || group.dataset.handle || '';
        group.querySelectorAll('input[data-variant-input]').forEach(input => {
          const label = Array.from(group.querySelectorAll('label')).find(item => item.htmlFor === input.id);
          if (!label) return;
          const display = displayLabel(input.value, optionName, this.locale);
          if (label.classList.contains('color-swatch')) {
            const appearance = scope.getComputedStyle(label);
            label.style.setProperty('--solid-swatch-color', appearance.backgroundColor);
            label.style.setProperty('--solid-swatch-image', appearance.backgroundImage);
          }
          input.setAttribute('aria-label', display);
          label.textContent = display;
          label.title = display;
        });
      });
      this.updateSelectedColor = this.updateSelectedColor.bind(this);
      this.onChange = () => scope.queueMicrotask(this.updateSelectedColor);
      this.productSection.addEventListener('change', this.onChange);
      this.productSection.addEventListener('variantChange', this.updateSelectedColor);
      this.observer = new MutationObserver(this.updateSelectedColor);
      this.querySelectorAll('[data-variant-color-label]').forEach(label => {
        this.observer.observe(label, { childList: true, characterData: true, subtree: true });
      });
      this.updateSelectedColor();
      this.sticky = new SolidStickyCart(this, scope);
      this.classList.add('is-enhanced');
    }

    setupSiblings() {
      const source = this.querySelector('[data-solid-siblings]');
      const colorGroup = this.querySelector('.variant-input-wrap[data-index="option1"]');
      const sizeGroup = this.querySelector('.variant-input-wrap[data-index="option2"]');
      if (!source || !colorGroup || !sizeGroup) return;
      const links = Array.from(source.querySelectorAll('[data-solid-color]'));
      try {
        this.siblingLinks = links.map(link => ({ link, variants: JSON.parse(link.dataset.variants) }));
      } catch {
        return;
      }
      if (links.length !== 26 || this.siblingLinks.some(item => !Array.isArray(item.variants))) return;
      this.siblingNav = source;
      this.colorGroup = colorGroup;
      this.sizeGroup = sizeGroup;
      colorGroup.parentElement.append(source);
      colorGroup.hidden = true;
      navigation.element = this;
      scope.document.documentElement.classList.add('leveret-solid-ajax-active');
      this.rememberHistory();
      this.onSubmit = event => {
        const variant = this.guardVariantIdentity();
        if (this.hasAttribute('aria-busy') || !variant?.available || this.productSection.querySelector('[data-add-to-cart]')?.classList.contains('btn--loading')) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      };
      this.addEventListener('submit', this.onSubmit, true);
      this.onSiblingClick = event => {
        const link = event.target.closest('[data-solid-color]');
        if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (this.productSection.querySelector('[data-add-to-cart]')?.classList.contains('btn--loading')) {
          event.preventDefault();
          return;
        }
        const notice = this.siblingNav.querySelector('[data-solid-color-notice]');
        if (link.getAttribute('aria-disabled') === 'true') {
          event.preventDefault();
          notice.textContent = this.siblingNav.dataset.unavailableMessage;
          notice.hidden = false;
          return;
        }
        if (link.dataset.productHandle !== this.productSection.dataset.productHandle) {
          event.preventDefault();
          navigation.load(link.href);
          return;
        }
        navigation.cancel();
        const input = Array.from(this.colorGroup.querySelectorAll('input[data-variant-input]')).find(item => item.value === link.dataset.solidColor);
        if (input) {
          event.preventDefault();
          input.click();
          this.updateSiblingLinks();
        }
      };
      source.addEventListener('click', this.onSiblingClick);
      this.onSiblingIntent = event => {
        const link = event.target.closest('[data-solid-color]');
        if (link && link.getAttribute('aria-disabled') !== 'true' && link.dataset.productHandle !== this.productSection.dataset.productHandle) navigation.prefetch(link.href);
      };
      source.addEventListener('pointerover', this.onSiblingIntent);
      source.addEventListener('focusin', this.onSiblingIntent);
    }

    rememberHistory() {
      if (!this.siblingNav || this.hasAttribute('aria-busy')) return;
      scope.history.replaceState({ ...scope.history.state, leveretSolid: { url: scope.location.href, scroll: [scope.scrollX, scope.scrollY] } }, '', scope.location.href);
    }

    setLoading(loading) {
      const notice = this.querySelector('[data-solid-load-status]');
      if (notice) notice.hidden = !loading;
      if (loading) {
        this.setAttribute('aria-busy', 'true');
        this.disabledDuringLoad = Array.from(this.querySelectorAll('button,input,select')).map(input => ({ input, disabled: input.disabled }));
        this.disabledDuringLoad.forEach(({ input }) => { input.disabled = true; });
      } else {
        this.removeAttribute('aria-busy');
        this.disabledDuringLoad?.forEach(({ input, disabled }) => { input.disabled = disabled; });
        this.disabledDuringLoad = null;
      }
      this.sticky?.schedule?.();
    }

    guardVariantIdentity() {
      if (!this.siblingNav) return null;
      const color = this.colorGroup.querySelector('input:checked')?.value;
      const size = this.sizeGroup.querySelector('input:checked')?.value;
      let variant;
      try { variant = JSON.parse(this.querySelector('[data-variant-json]').textContent).find(item => item.option1 === color && item.option2 === size); } catch { return null; }
      const master = this.querySelector('[data-product-select]');
      if (variant && master) {
        let option = Array.from(master.options).find(item => item.value === String(variant.id));
        if (!option) {
          option = scope.document.createElement('option');
          option.value = String(variant.id);
          option.textContent = variant.title;
          option.disabled = !variant.available;
          master.append(option);
        }
        master.value = String(variant.id);
      }
      const dynamic = this.querySelector('.shopify-payment-button');
      if (dynamic) dynamic.hidden = !variant?.available;
      if (!variant?.available) {
        this.querySelectorAll('[data-add-to-cart]').forEach(button => { button.disabled = true; });
      }
      return variant;
    }

    updateSiblingLinks() {
      if (!this.siblingNav) return;
      const size = this.sizeGroup.querySelector('input:checked');
      const color = this.colorGroup.querySelector('input:checked');
      if (!size || !color) return;
      this.siblingNav.querySelector('[data-solid-color-notice]').hidden = true;
      this.siblingLinks.forEach(({ link, variants }) => {
        const previousUrl = link.href;
        const label = displayLabel(link.dataset.solidColor, 'Color', this.locale);
        link.querySelector('[data-solid-color-name]').textContent = label;
        const state = siblingState(link.dataset.productUrl, variants, size.value, scope.location.href, this.reviewView);
        link.setAttribute('aria-disabled', String(!state));
        link.classList.toggle('is-sold-out', Boolean(state && !state.available));
        link.title = label + (state && !state.available ? ' — ' + this.siblingNav.dataset.soldOutMessage : '');
        if (state) link.href = state.url;
        else link.removeAttribute('href');
        if (previousUrl !== link.href) delete link.dataset.solidPrefetch;
        if (link.dataset.productHandle === this.productSection.dataset.productHandle && link.dataset.solidColor === color.value) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
      const warmKey = this.productSection.dataset.productHandle + ':' + size.value;
      if (warmKey !== this.warmKey) {
        this.warmKey = warmKey;
        scope.clearTimeout(this.warmTimer);
        this.warmTimer = scope.setTimeout(() => {
          if (!this.isConnected || this.hasAttribute('aria-busy')) return;
          const warmed = new Set([this.productSection.dataset.productHandle]);
          this.siblingLinks.forEach(({ link }) => {
            if (warmed.has(link.dataset.productHandle) || link.getAttribute('aria-disabled') === 'true') return;
            warmed.add(link.dataset.productHandle);
            navigation.prefetch(link.href);
          });
        }, 350);
      }
    }

    updateSelectedColor() {
      if (this.hasAttribute('aria-busy')) return;
      const url = reviewUrl(scope.location.href, this.reviewView);
      if (url !== scope.location.href) scope.history.replaceState(scope.history.state, '', url);
      this.querySelectorAll('[data-variant-color-label]').forEach(label => {
        const group = this.querySelector('.variant-input-wrap[data-index="option' + (Number(label.dataset.index) + 1) + '"]');
        const selected = group && group.querySelector('input[data-variant-input]:checked');
        if (!selected) return;
        const display = displayLabel(selected.value, group.getAttribute('name') || group.dataset.handle, this.locale);
        if (label.textContent !== display) label.textContent = display;
      });
      this.updateSiblingLinks();
      this.guardVariantIdentity();
      this.rememberHistory();
      this.sticky?.schedule?.();
    }

    disconnectedCallback() {
      this.sticky?.disconnect();
      this.sticky = null;
      if (this.observer) this.observer.disconnect();
      if (this.siblingNav) this.siblingNav.removeEventListener('click', this.onSiblingClick);
      if (this.siblingNav) {
        this.siblingNav.removeEventListener('pointerover', this.onSiblingIntent);
        this.siblingNav.removeEventListener('focusin', this.onSiblingIntent);
      }
      scope.clearTimeout(this.warmTimer);
      this.warmKey = null;
      if (this.onSubmit) this.removeEventListener('submit', this.onSubmit, true);
      if (this.productSection) {
        this.productSection.removeEventListener('change', this.onNativeChange, true);
        this.productSection.removeEventListener('change', this.onChange);
        this.productSection.removeEventListener('variantChange', this.updateSelectedColor);
      }
      this.initialized = false;
    }
  });
})(typeof window === 'undefined' ? globalThis : window);
